module.exports = __webpack_public_path__ + "static/media/BB6.3239e816.png";